import {
    computed,
    DestroyRef,
    Directive,
    inject,
    input,
    type OnInit,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatRadioButton } from '@angular/material/radio';
import { distinctUntilChanged } from 'rxjs';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'mat-radio-button[qpx]',
    host: {
        '[attr.id]': 'id()',
        '[class]': 'className()',
    },
})
export class QpxRadio implements OnInit {
    private readonly radio = inject(MatRadioButton, { host: true });
    private readonly destroyRef = inject(DestroyRef);

    public readonly id = input.required<string>();
    public readonly ripple = input<boolean>(false);
    private readonly ripple$ = toObservable(this.ripple);

    public readonly context = input<'primary' | 'accent' | 'warn'>('primary');
    private readonly context$ = toObservable(this.context);

    protected readonly className = computed(() => {
        const _classNames = ['qpx-radio', `mat-${this.context()}`];
        return _classNames.join(' ');
    });

    ngOnInit(): void {
        this.ripple$
            .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (value) => (this.radio.disableRipple = !value),
            });

        this.context$
            .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (value) => (this.radio.color = value),
            });
    }
}
